import React, {  useState } from "react";
import ReactDOM from "react-dom";
import axios from 'axios'
import './Thermophysical.css'

const Thermophysical = () => {

    const [inp, setInp] = useState([])

    const handleInputChange = (event, index) => {
        const newInp = [...inp]; // Create a copy of the inputs array
        newInp[index] = event.target.value; // Update the value at the corresponding index
        setInp(newInp); // Update the state variable with the new array
      };

    function pressedPredict(e){
        console.log(inp)
        let sum = 0;
        for(var i = 0; i < inp.length; i++){
            sum += +inp[i]
        }

        console.log(sum)

        if(sum === 100){
            setFirstClick(true)
            callApi(e)
        }
        else{
            ReactDOM.render(<p>Invalid Composition!</p>, document.getElementById('inval-res'))
        }
    }

    const [liq, setLiq] = useState('')
    const [enthal, setEnthal] = useState('')
    const [entrop, setEntrop] = useState('')
    const [gibbs, setGibbs] = useState('')
    const [specheat, setSpecheat] = useState('')
    const [firstClick,setFirstClick] = useState(false)

    async function callApi(e) {
        e.preventDefault();
        axios
          .post("https://thermophysical-predictor.onrender.com/api/predictNew/", {
            inp : inp
          })
          .then((resp) => {
             setLiq (resp.data.liq_result)
             setEnthal (resp.data.enthal_result)
             setEntrop (resp.data.entrop_result)
             setGibbs (resp.data.gibbs_result)
             setSpecheat (resp.data.shc_result)
          })
          .catch((error) => {
            console.error(error.response);
          });
      }


  return (
    <>
        <div className="instructions">
            <h4>Instructions:</h4>
            <ul>
                <li>Enter valid compositions (Wt%) of the blast furnace hearth slag.</li>
                <li>Note: The prediction works well in the high alumina regime i.e. Al<sub>2</sub>O<sub>3</sub>&gt;=15%</li>
            </ul>
        </div>
        <div className="section">
            <div className="container d-flex p-3" style={{ "justifyContent" : "center", "fontSize" : "20px" }}>
                <div>
                <p>Al<sub>2</sub>O<sub>3</sub></p>  <input placeholder="Composition" step=".01" type="number" style = {{width : "60%", fontSize : "12px"}} value={inp[0] || ''} onChange={(event) => handleInputChange(event, 0)} required/>
                </div>
                <div>
                <p>MgO</p>  <input placeholder="Composition" step=".01" type="number" style = {{width : "60%", fontSize : "12px"}} value={inp[1] || ''} onChange={(event) => handleInputChange(event, 1)} required/>
                </div>
                <div>
                <p>CaO</p>  <input placeholder="Composition" step=".01" type="number" style = {{width : "60%", fontSize : "12px"}} value={inp[2] || ''} onChange={(event) => handleInputChange(event, 2)} required/>
                </div>
                <div>
                <p>SiO<sub>2</sub></p>  <input placeholder="Composition" step=".01" type="number" style = {{width : "60%", fontSize : "12px"}} value={inp[3] || ''} onChange={(event) => handleInputChange(event, 3)} required/>
                </div>
            </div>
        </div>
        <div className="btn-container" style={{"zIndex" : "1", "position" : "relative"}}>
        <button className="btn btn-primary" style={{"margin" : "1%"}}  onClick={(e) => { pressedPredict(e) }}>Predict</button>
        <button className = "btn btn-danger"  onClick={() => {window.location.reload(false)}}>Clear</button>
      </div>
      <div id="pred-res">
        {firstClick? <><h3>Results</h3><table className="table-content">
                <thead className="table-head">
                    <tr>
                        <th className="border">Liquidus Temperature (K)</th>
                        <th className="border">Enthalpy Change (kJ)</th>
                        <th className="border">Entropy Change (J/K)</th>
                        <th className="border">Specific Heat Capacity Change (J/K/kg)</th>
                        <th className="border">Gibbs free energy (kJ)</th>
                    </tr>
                </thead>
                <tbody className="table-body">
                    <tr>
                        <td className="border">{liq}</td>
                        <td className="border">{enthal}</td>
                        <td className="border">{entrop}</td>
                        <td className="border">{specheat}</td>
                        <td className="border">{gibbs}</td>
                    </tr>
                </tbody>
            </table></> : <></>}
      </div>
      <div id="inval-res"></div>
      <div className="footer">Developed by Devi Dutta Biswajeet - <a href="https://www.snehanshuresearchlab.org/Profiles/Devi%20Dutta%20Biswajeet.html" style={{"textDecoration" : "none"}}>Profile</a></div>
    </>
  )
}

export default Thermophysical;
